import {genericMandarkRequest} from 'resources/mandark.resource';

export function bulkCreateClassroomInvitations(invitations) {
  return genericMandarkRequest(
    'post',
    {
      resourcePath: ['json', 'classroom_invitations', 'bulk']
    },
    {
      data: {
        attributes: invitations
      }
    }
  );
}
